import axios, { getData } from "lib/axios"


export const presignURL = async (data) => {
    return axios.post("/presign-url",data).then(getData)
}

export const storeOrganizationLogo = async (data) => {
    return axios.post("/organization-logo",data).then(getData)
}

export const storeProfilePhoto = async (data) => {
    return axios.post("/staff-profile-image",data).then(getData)
}


